import { render, staticRenderFns } from "./LocationGoogleRating.vue?vue&type=template&id=95cb55d4&"
import script from "./LocationGoogleRating.vue?vue&type=script&lang=js&"
export * from "./LocationGoogleRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95cb55d4')) {
      api.createRecord('95cb55d4', component.options)
    } else {
      api.reload('95cb55d4', component.options)
    }
    module.hot.accept("./LocationGoogleRating.vue?vue&type=template&id=95cb55d4&", function () {
      api.rerender('95cb55d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/LocationGoogleRating.vue"
export default component.exports